import { memo, useState, FC } from 'react'

import { CloseEyeIcon, CrossCircleIcon, OpenEyeIcon, SearchIcon } from '@App/static/icons/InputComponentIcons'

import { IInputProps } from '@UI/crypto_exchange/desktop/components/controls/InputComponent/types'

import classes from './Input.module.scss'

export const InputComponent: FC<IInputProps> = memo(
  ({
    name,
    type,
    className = null,
    required = null,
    watch = null,
    error = null,
    pattern = null,
    register,
    setValue,
    placeholder,
    defaultValue = null,
    isSearch = false,
    maxLength = null,
    max = null,
    customCrossIcon = null,
    label = '',
    additionalButton = '',
    additionalButtonCallback = () => {},
  }) => {
    const [passVisibility, setPassVisibility] = useState(false)

    const clearInputField = () => {
      setValue && setValue(name, '')
    }

    return (
      <div>
        <div className={classes.inputLabel}>{label}</div>
        <div className={classes.inputContainer}>
          {isSearch && (
            <span className={classes.searchIcon}>
              <SearchIcon className={classes.search} width={24} height={24} />
            </span>
          )}
          <input
            id={name}
            type={passVisibility ? 'text' : type}
            className={`${classes.input} ${className} ${error && classes.helpErrorBorder} ${
              isSearch ? classes.paddingLeft : null
            }`}
            {...register(name, {
              required: required,
              pattern: {
                value: pattern?.value,
                message: pattern?.message,
              },
            })}
            placeholder={placeholder}
            defaultValue={defaultValue}
            maxLength={maxLength}
            max={max}
          />

          <div className={classes.iconsContainer}>
            {watch && (
              <span onClick={() => clearInputField()} className={`${classes.icon} ${classes.iconClearInput}`}>
                {customCrossIcon ? customCrossIcon : <CrossCircleIcon />}
              </span>
            )}

            {type === 'password' && (
              <span
                className={`${classes.icon} ${classes.iconPassword}`}
                onClick={() => setPassVisibility(!passVisibility)}
              >
                {passVisibility ? <OpenEyeIcon /> : <CloseEyeIcon />}
              </span>
            )}
            {additionalButton && additionalButtonCallback && (
              <span className={classes.additionalText} onClick={additionalButtonCallback}>
                {additionalButton}
              </span>
            )}
          </div>
        </div>
        {error && <div className={classes.errorContainer}>{error.message as string}</div>}
      </div>
    )
  },
)
